import { Slide } from "@jelly/lesson";
import { task as task02 } from "../../../../../task/course-03/lesson-06/task-02";

const task: Slide = {
  titleHtml: `The image source model and the ray tracing algorithm a popular models to predict<br>the propagation of sound waves in rooms. In this task, you need to assign advantages<br>and disadvantages to these two approaches.`,
  description: "Drag and drop elements. ",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
